import api from './apiClient';
import { Notification, NotificationCreate, NotificationStats, NotificationRecipient } from '../types';

export const notificationService = {
  createNotification: async (data: NotificationCreate): Promise<Notification> => {
    const response = await api.post('/notifications/', data);
    return response.data;
  },

  getNotifications: async (skip: number = 0, limit: number = 100): Promise<Notification[]> => {
    const response = await api.get(`/notifications/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  getNotification: async (id: number): Promise<Notification> => {
    const response = await api.get(`/notifications/${id}`);
    return response.data;
  },

  updateNotification: async (id: number, data: Partial<NotificationCreate>): Promise<Notification> => {
    const response = await api.put(`/notifications/${id}`, data);
    return response.data;
  },

  deleteNotification: async (id: number): Promise<void> => {
    await api.delete(`/notifications/${id}`);
  },

  sendNotification: async (id: number): Promise<void> => {
    await api.post(`/notifications/${id}/send`);
  },

  getNotificationStats: async (): Promise<NotificationStats> => {
    const response = await api.get('/notifications/stats');
    return response.data;
  },

  getNotificationRecipients: async (id: number): Promise<NotificationRecipient[]> => {
    const response = await api.get(`/notifications/${id}/recipients`);
    return response.data;
  },

  getMyNotifications: async (unreadOnly: boolean = false): Promise<NotificationRecipient[]> => {
    const response = await api.get(`/notifications/user/my-notifications?unread_only=${unreadOnly}`);
    return response.data;
  },

  markAsRead: async (id: number): Promise<void> => {
    await api.post(`/notifications/${id}/mark-read`);
  },
};








